/*************************************************************
 *
 *  Copyright (c) 2018-2022 Omar Al-Ithawi and The MathJax Consortium
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

/**
 * @fileoverview Constants file for the color package.
 *
 * @author i@omardo.com (Omar Al-Ithawi)
 */

export const COLORS: Map<string, string> = new Map<string, string>([
  ['Apricot', '#FBB982'],
  ['Aquamarine', '#00B5BE'],
  ['Bittersweet', '#C04F17'],
  ['Black', '#221E1F'],
  ['Blue', '#2D2F92'],
  ['BlueGreen', '#00B3B8'],
  ['BlueViolet', '#473992'],
  ['BrickRed', '#B6321C'],
  ['Brown', '#792500'],
  ['BurntOrange', '#F7921D'],
  ['CadetBlue', '#74729A'],
  ['CarnationPink', '#F282B4'],
  ['Cerulean', '#00A2E3'],
  ['CornflowerBlue', '#41B0E4'],
  ['Cyan', '#00AEEF'],
  ['Dandelion', '#FDBC42'],
  ['DarkOrchid', '#A4538A'],
  ['Emerald', '#00A99D'],
  ['ForestGreen', '#009B55'],
  ['Fuchsia', '#8C368C'],
  ['Goldenrod', '#FFDF42'],
  ['Gray', '#949698'],
  ['Green', '#00A64F'],
  ['GreenYellow', '#DFE674'],
  ['JungleGreen', '#00A99A'],
  ['Lavender', '#F49EC4'],
  ['LimeGreen', '#8DC73E'],
  ['Magenta', '#EC008C'],
  ['Mahogany', '#A9341F'],
  ['Maroon', '#AF3235'],
  ['Melon', '#F89E7B'],
  ['MidnightBlue', '#006795'],
  ['Mulberry', '#A93C93'],
  ['NavyBlue', '#006EB8'],
  ['OliveGreen', '#3C8031'],
  ['Orange', '#F58137'],
  ['OrangeRed', '#ED135A'],
  ['Orchid', '#AF72B0'],
  ['Peach', '#F7965A'],
  ['Periwinkle', '#7977B8'],
  ['PineGreen', '#008B72'],
  ['Plum', '#92268F'],
  ['ProcessBlue', '#00B0F0'],
  ['Purple', '#99479B'],
  ['RawSienna', '#974006'],
  ['Red', '#ED1B23'],
  ['RedOrange', '#F26035'],
  ['RedViolet', '#A1246B'],
  ['Rhodamine', '#EF559F'],
  ['RoyalBlue', '#0071BC'],
  ['RoyalPurple', '#613F99'],
  ['RubineRed', '#ED017D'],
  ['Salmon', '#F69289'],
  ['SeaGreen', '#3FBC9D'],
  ['Sepia', '#671800'],
  ['SkyBlue', '#46C5DD'],
  ['SpringGreen', '#C6DC67'],
  ['Tan', '#DA9D76'],
  ['TealBlue', '#00AEB3'],
  ['Thistle', '#D883B7'],
  ['Turquoise', '#00B4CE'],
  ['Violet', '#58429B'],
  ['VioletRed', '#EF58A0'],
  ['White', '#FFFFFF'],
  ['WildStrawberry', '#EE2967'],
  ['Yellow', '#FFF200'],
  ['YellowGreen', '#98CC70'],
  ['YellowOrange', '#FAA21A'],
]);
